import { render, staticRenderFns } from "./origin-select.vue?vue&type=template&id=371466a2"
import script from "./origin-select.vue?vue&type=script&lang=js"
export * from "./origin-select.vue?vue&type=script&lang=js"
import style0 from "./origin-select.vue?vue&type=style&index=0&id=371466a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports